export default __webpack_public_path__ + "static/media/Tiger's Girdle of the Untamed.83df6bbe.jpg";